import React from "react";
import InfoGridList from "./infoGridList";
import { useCellRender } from "../hooks/useCellRender";
import { DATA_DN_STATUS, DATA_DN_PAYMENT_STATUS } from "../data/options";
import { Alert, Group, Button } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons";
import _ from "lodash";
import moment from "moment";

export default function AIRequestSummary({ form, name }) {
  const [cellRender] = useCellRender();
  const aiRequest = form.values;

  const handleReset = async () => {
    if (window.confirm("Are you sure to reset the AI Request?")) {
      await form.updateAndSave({ status: "PENDING", outputs: [] });
      // form.reload();
    }
  };

  const fields = [
    {
      title: "Code",
      value: aiRequest.code,
    },

    {
      title: "Status",
      value: aiRequest.status ? (
        <Group>
          {/* {cellRender.Order.status(aiRequest?.status)} */}
          {aiRequest?.status}

          {aiRequest.status !== "COMPLETED" &&
            aiRequest.status !== "PENDING" && (
              <Button
                variant="light"
                size="xs"
                color="red"
                onClick={() => {
                  handleReset();
                }}
              >
                Reset
              </Button>
            )}
        </Group>
      ) : (
        "Unknown"
      ),
    },

    {
      title: "Type",
      value: aiRequest?.type ? <Group>{aiRequest?.type}</Group> : "Unknown",
    },

    {
      title: "Description",
      value: aiRequest.description,
    },

    {
      title: "Created At",
      value: moment(aiRequest.createdAt).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: "Updated At",
      value: moment(aiRequest.updatedAt).format("YYYY-MM-DD HH:mm:ss"),
    },
  ];

  if (aiRequest.payload && aiRequest.payload.email) {
    fields.push({
      title: "Email",
      value: aiRequest.payload.email.subject,
    });
  }

  if (aiRequest.output && aiRequest.output.type) {
    fields.push({
      title: "DN Type",
      value: aiRequest.output.type,
    });
  }

  if (aiRequest.output && aiRequest.output.type && aiRequest.output.code) {
    fields.push({
      title: "DN Code",
      value: aiRequest.output.code,
    });
  }

  return (
    aiRequest && (
      <>
        <InfoGridList fields={fields} values={aiRequest} />
      </>
    )
  );
}
